'use strict';

class AnalyticsService {
  constructor(BaseService) {
    // noinspection BadExpressionStatementJS
    'ngInject';

    const service = new BaseService();
    this.http = service.http;
    this.baseUrl = service.baseUrl;
    this.requestSuccess = service.requestSuccess;
    this.requestFailure = service.requestFailure;
  }

  getCustomerAnalytics() {
    return this.http.get(`${this.baseUrl}/analytics/customers`)
      .then(this.requestSuccess)
      .catch(this.requestFailure);
  }

  /**
   * @typedef MissedCustomer
   * customerName {string}
   * postcode {string}
   */

  /**
   * @return {Promise.<MissedCustomer[]>}
   */
  getMissedCustomerOrders() {
    return this.http.get(`${this.baseUrl}/analytics/customers/missed`)
      .then(this.requestSuccess)
      .catch(this.requestFailure);
  }
}

/**
 * @ngdoc service
 * @name gfcmsApp.analytics.service
 * @description
 * # analytics.service
 * Service in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .service('analyticsService', AnalyticsService);
